import { render, staticRenderFns } from "./Demission.vue?vue&type=template&id=49914702"
import script from "./Demission.vue?vue&type=script&lang=js"
export * from "./Demission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports